<template>
    <span>
    <v-flex xs12>
           <confirmation-header-text class="mx-0 my-2 "
                                     text="Appointment Date"
                                     description="[ Note: Application will only be served on appointment date ]"
                                     icon="mdi-av-timer"/>

    </v-flex>
    <v-flex md12 class="mt-2">
           <span v-for="day_data in days_array" :key="day_data.day" :class="{'my-4':day_data.available}">
                   <v-btn class="ma-2" :outlined="!(day_data.day === date)"
                          large
                          :color="day_data.day === date?'primary':'indigo'" :disabled="!day_data.available"
                          @click="setValue(day_data.day)"
                   >

                             <div>

                             <div>
                                 {{day_data.available_token}}/{{day_data.total_token}}
                             </div>
                             <div>
                                                          available &nbsp;
                             </div>
                                                              </div>
                       <!--                </v-chip>-->

                       {{day_data.day}} <br> ({{day_data.week_day}})
                   </v-btn>
           </span>
    </v-flex>
            </span>
</template>

<script>
    import moment from "moment"
    import ConfirmationHeaderText from "../components/ConfirmationHeaderText";
    import {validationMixin} from "../mixins/validationMixin";
    import Http from "axios"
    import {API_URL, VERSION} from "../config/config";

    export default {
        name: "AppointmentDatePicker",
        components: {
            ConfirmationHeaderText
        },
        props: ['value', 'type'],
        mixins: [validationMixin],
        data() {
            return {
                date: null,
                menu: false,
                appointment_dates: []
                // min_date: new Date().toISOString().substr(0, 10)
            }
        },
        watch: {
            value() {
                if (this.value) {
                    this.date = this.value
                }
            },
            date() {
                this.$emit('input', this.date)
            }
        },
        computed: {
            days_array() {
                const has_appointment_today = this.$store.state.VisaSingle.extendConvertVisaDetail.has_appointment_today;
                const days_array = [];
                const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
                for (let i = 0; i <= 10; i++) {
                    const loop_day = moment().add(i, 'days').format("YYYY-MM-DD")
                    let total_token = 0;
                    let available_token = 0;
                    const day_data = this.appointment_dates.find(i => i.date === loop_day)
                    console.log(this.type)
                    if (day_data !== undefined) {
                        switch (this.type) {
                            case "tourist-visa": {
                                total_token = day_data.tourist_token
                                available_token = total_token - day_data.tourist_count
                                break
                            }
                            case "business-visa": {
                                total_token = 100
                                available_token = 100
                                break
                            }
                            case "dependent-visa": {
                                total_token = 100
                                available_token = 100
                                break
                            }
                            default: {
                                total_token = day_data.non_tourist_token

                                available_token = total_token - day_data.non_tourist_count
                            }
                        }
                    }

                    let token_available = false;

                    if (loop_day === new Date().toISOString().substring(0, 10)) {
                        token_available = has_appointment_today;
                    } else {
                        token_available = available_token > 0;
                    }


                    days_array.push({
                        day: loop_day,
                        available: token_available,
                        total_token,
                        week_day: days[moment().add(i, 'days').weekday()],
                        available_token
                    })
                }
                return days_array;
            }
        },
        methods: {
            setValue(value) {
                this.date = value;
                this.$emit('input', value)
            }
        },
        mounted() {
            if (this.value) {
                this.date = this.value
            }
            Http.get(`${API_URL}${VERSION}/appointment-detail-for-week`).then((res) => {
                this.appointment_dates = res.data.data;
            })
        }
    }
</script>
